import moment from "moment";
import { createReducer } from "typesafe-actions";
import withJobs from "../../_core/job/reducers";
import { IORB3Store } from "./@types";
import orb3Actions, { EORB3Constants, TORB3Actions } from "./actions";

const defaultState: IORB3Store = {
	_jobs: {},
	currentOperation: undefined,
	records: {
		byIds: {},
		ids: [],
	},
	filter: {
		startDate: moment().subtract(7, "days").toDate(),
		endDate: moment().add(1, "day").toDate(),
		shownRecords: "ALL",
		vesselId: "",
	},
};
const orb3Reducers = createReducer<IORB3Store, TORB3Actions>(defaultState)
	.handleAction(
		orb3Actions.document.historySet,
		function historySet(state, action) {
			return {
				...state,
				records: action.payload.history,
			};
		},
	)
	.handleAction(
		orb3Actions.document.setFilter,
		function setFilter(state, action) {
			return {
				...state,
				filter: action.payload.filter,
			};
		},
	);

export default withJobs<IORB3Store>(
	EORB3Constants.FEATURE,
	defaultState,
	orb3Reducers,
);
